import React , {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {  setCurrentStep, saveToHistory, pushToHistory, clearHistory } from './OrganizationEmployeeSlice';
import ButtonNextStep from 'app/Components/Shared/ButtonNextStep/ButtonNextStep';
const BtnNextStep = ({
  onclick,
  text,
  disabled = false,
  className = '',
  errorText,
  currentStep,
  setCurrentStep,
  nextStep,
  saveToHistory,
  pushToHistory,
  clearHistoryInd = false
}) => {


  return (
    <div className='btn-container'>
      <ButtonNextStep
        text={text || "המשך"}
        disabled={disabled}
        className={className}
        errorText={errorText}
        onclick={onclick}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        nextStep={nextStep}
        saveToHistory={saveToHistory}
        pushToHistory={pushToHistory}
        clearHistory={clearHistory}
        clearHistoryInd={clearHistoryInd}
      />
  </div>
  );
};

const mapStateToProps = (state) => ({
  currentStep: state.organizationEmployee.currentStep,
});

const mapDispatchToProps = {
  setCurrentStep,
  saveToHistory,
  pushToHistory,
  clearHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(BtnNextStep);
